import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";

function Contact() {
    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: Add form submission logic
        alert("Form submitted!");
    };

    return (
        <>
            <Header />

            {/* Inner Slider */}
            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">Contact</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Contact</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Inner Body */}
            <section className="innerBody contact">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Contact</h1>
                        </div>
                    </div>

                    <div className="row">
                        <form id="form1" onSubmit={handleSubmit}>
                            <div className="primary-alert"></div>
                            <div className="container curr-blk">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                name="txtname"
                                                type="text"
                                                id="name"
                                                className="form-control f-control"
                                                placeholder="Enter your Name"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                name="email"
                                                type="email"
                                                id="email"
                                                className="form-control f-control"
                                                placeholder="Enter your Email"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                name="phone"
                                                type="text"
                                                maxLength="10"
                                                id="phone"
                                                className="form-control f-control"
                                                placeholder="Enter your Phone"
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                name="txtclass"
                                                type="text"
                                                id="location"
                                                className="form-control f-control"
                                                placeholder="Enter your City"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <textarea
                                                name="message1"
                                                rows="10"
                                                id="message"
                                                className="form-control"
                                                placeholder="Enter your Message"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <input
                                                type="submit"
                                                name="btnsave"
                                                value="Submit"
                                                id="btnsave"
                                                className="btn btn-warning"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        {/* Map and Contact Info */}
                        <div className="container curr-blk">
                            <div className="row">
                                <div className="map-section">
                                    <div className="map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d58466.87621557623!2d86.07253928974121!3d23.669528564941814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sSt.+Mary%E2%80%99s+Nursery+School%2C+Bokaro+(SMNS)!5e0!3m2!1sen!2sin!4v1488881969139"
                                            width="100%"
                                            height="100%"
                                            frameBorder="0"
                                            style={{ border: 0, paddingTop: "6px", paddingLeft: "6px" }}
                                            allowFullScreen
                                            title="Google Map"
                                        ></iframe>
                                    </div>

                                    <div className="contact-area pt-lg-0 pb-lg-0">
                                        <div className="container">
                                            <div className="contact-wrapper">
                                                <div className="row">
                                                    {/* Class Sessions */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="contact-item">
                                                            <div className="contact-thumb">
                                                                <img
                                                                    src="https://webapi.entab.info/api/image/SMNSB/public/images/01.png"
                                                                    alt="Class Sessions"
                                                                />
                                                            </div>
                                                            <div className="contact-content">
                                                                <h6 className="title">Class Sessions</h6>
                                                                <ul>
                                                                    <li>Monday - Friday</li>
                                                                    <li>08.00 am – 12.00 Noon</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* SMNS Address */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="contact-item">
                                                            <div className="contact-thumb">
                                                                <img
                                                                    src="https://webapi.entab.info/api/image/SMNSB/public/images/02.png"
                                                                    alt="Address"
                                                                />
                                                            </div>
                                                            <div className="contact-content">
                                                                <h6 className="title">SMNS Address</h6>
                                                                <ul>
                                                                    <li>Sector - 4 - C, Near City Church, Bokaro Steel City, India 827004</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Office Hours */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="contact-item">
                                                            <div className="contact-thumb">
                                                                <img
                                                                    src="https://webapi.entab.info/api/image/SMNSB/public/images/03.png"
                                                                    alt="Office Hours"
                                                                />
                                                            </div>
                                                            <div className="contact-content">
                                                                <h6 className="title">Office Hours</h6>
                                                                <ul>
                                                                    <li>Monday - Saturday</li>
                                                                    <li>08.00 am – 02.00 pm</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Contact Info */}
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="contact-item">
                                                            <div className="contact-thumb">
                                                                <img
                                                                    src="https://webapi.entab.info/api/image/SMNSB/public/images/04.png"
                                                                    alt="Contact"
                                                                />
                                                            </div>
                                                            <div className="contact-content">
                                                                <h6 className="title">Phone & E-mail</h6>
                                                                <ul>
                                                                    <li>
                                                                        <b>Call Us:</b> <a href="tel:06542232938">06542 232938</a>
                                                                    </li>
                                                                    <li>
                                                                        <b>WhatsApp:</b>{" "}
                                                                        <a href="https://wa.me/+916205447455" target="_blank" rel="noopener noreferrer">
                                                                            +91 6205 447 455
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="mailto:smnsbokaro@rediffmail.com">smnsbokaro@rediffmail.com</a>,{" "}
                                                                        <a href="mailto:smnsoffice@gmail.com">smnsoffice@gmail.com</a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    );
}

export default Contact;
